var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        class: _vm.oncapture ? "show" : "show",
        style: _vm.oncapture ? "display: block; padding-left: 0px;" : "",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
          [
            _c("div", { staticClass: "modal-content shadow-3" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4",
                  },
                  [_c("i", { staticClass: "bi bi-camera" })]
                ),
                _vm._v(" "),
                _c("div", [
                  _c("h5", { staticClass: "mb-1" }, [
                    _vm._v("Fotografias del Paquete"),
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "d-block text-xs text-muted" }, [
                    _vm._v("Archivo desde la cámara web"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ms-auto" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "vstack gap-3" }, [
                  _c(
                    "div",
                    [
                      _c("camera", {
                        attrs: { closecamare: _vm.closecamare },
                        on: {
                          capture: _vm.CAPTURE,
                          closeerror: function ($event) {
                            return _vm.$emit("close")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.images, function (item, index) {
                      return _c(
                        "div",
                        { staticClass: "col-md-4 mb-2 position-relative" },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: { src: "" + item.path },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-m position-absolute cursor-point btn-danger rounded-circle",
                              staticStyle: { right: "-2px", top: "-8px" },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.REMOVE(index)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa-solid fa-close" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: item.path,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-success px-3",
                    attrs: { type: "button", disabled: _vm.images.length == 0 },
                    on: {
                      click: function ($event) {
                        return _vm.SAVE()
                      },
                    },
                  },
                  [_vm._v("Guardar fotografias tomadas")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-dark px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.CLOSE()
                      },
                    },
                  },
                  [_vm._v("Cerrar")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }